import React from 'react'
import CkMuiDialog from './CkMuiDialog/CkMuiDialog';
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { OneMealServiceStatus } from '../../enums/OneMealServiceStatus';
import { OneMealService } from '../../services/OneMealService';
import EventBus from '../../EventBus';
import { EventBusEventsEnum } from '../../enums/EventBusEventsEnum';
import { CustomSnackbarTypes } from './CustomSnackBar';
import { useRecordContext, useRefresh } from 'react-admin';
import ChefForPartStatusEnum from '../../enums/ChefForPartStatusEnum';
import ChefForPartyService from '../../services/ChefForPartyService';

interface InputProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  forParty?: boolean;
}

const oneMealService = new OneMealService();
const chefForPartyService = new ChefForPartyService();
const UpdateOMSStatusDialog = (props: InputProps) => {
    const record = useRecordContext();
    const refresh = useRefresh();
    const [selectedStatus, setSelectedStatus] = React.useState<OneMealServiceStatus>(OneMealServiceStatus.ONGOING);
    const handleUpdate = () => {
        if (selectedStatus && record?.id) {
            const payload = {
                bookingStatus: selectedStatus,
            }
            if(props?.forParty){
                chefForPartyService.updatePartyStatus(record?.id as number, payload).then((res) => {
                    if (res) {
                        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                            message: "Updated Successfully",
                            type: CustomSnackbarTypes.SUCCESS,
                        });
                        refresh();
                        props?.setOpen(false);
                    }
                })
                return;
            }
            oneMealService?.updateOMSStatus(record?.id as number, payload).then((res) => {
                if (res) {
                    EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                        message: "Updated Successfully",
                        type: CustomSnackbarTypes.SUCCESS,
                    });
                    refresh();
                    props?.setOpen(false);
                }
            })
        }
    }
  return (
    <CkMuiDialog
        fullWidth
        maxWidth='xs'
        isDialogOpen={props?.open}
        setDialogOpen={props?.setOpen}
        onDialogClose={() => {}}
        title={!props?.forParty ? "OMS Status Update" : 'Update Party Status'}
        primaryLabel={"Submit"}
        primaryAction={handleUpdate}
        secondaryLabel={"Cancel"}
        secondaryAction={() => {
            props?.setOpen(false);
        }}
        isLoading={false}
    >
      <Box>
        <FormControl fullWidth>
            <InputLabel id="update_status">Update Status</InputLabel>
            <Select
                labelId="for_slot"
                id="Select Service"
                label="Select Service"
                value={selectedStatus}
                onChange={(event) => setSelectedStatus(event?.target?.value as OneMealServiceStatus)}
            >
                {Object.keys(!props.forParty ? OneMealServiceStatus : ChefForPartStatusEnum).map((status: any) => (
                    <MenuItem key={status} value={status}>
                      {status}
                    </MenuItem>
                  ))}
            </Select>
        </FormControl>
      </Box>
    </CkMuiDialog>
  )
}

export default UpdateOMSStatusDialog